/**
 * The words of the page's side of the Asset Studio: what a request to the studio's routes says when it did not reach
 * the server, was refused or did not read, and the two refusals of the timing routes. Each is a draft for the author.
 * Sentence case, with no full stop, since the studio shows them as one line. `{wait}` in `rate` is one of
 * `wait.seconds`, `wait.minutes` or `wait.later`; `{status}` is an HTTP status and `{code}` the answer's `error`;
 * `{reason}` is what reading the answer threw, as it came.
 */
export const STUDIO = {
  unreached: "The server could not be reached; check the connection and try again",
  signInEnded: "Your sign-in has ended; sign in again and retry",
  noCapability: "This account may not use the Asset Studio",
  rate: "Too many requests at once; try again {wait}",
  gateway: "The game's server did not answer the sign-in check; try again in a moment",
  tooLarge: "The request is too large",
  serviceClient: "This route is not open to a service client; sign in as a builder",
  refusedCoded: "The server refused the request ({status} {code})",
  refused: "The server refused the request ({status})",
  notRead: "The answer did not read: {reason}",
  wait: {
    later: "later",
    seconds: { one: "in {count} second", other: "in {count} seconds" },
    minutes: { one: "in {count} minute", other: "in {count} minutes" },
  },
  timing: {
    noStrip: "This is not a strip the pack holds, so it has no timing to read",
    notTaken: "The server did not take this timing; nothing was saved",
  },
} as const;
